import polyfills from './polyfills';
import hydrate from './hydrate';

polyfills().then(() => hydrate()).catch((err) => console.log('DEBUG: polyfills erroring', err));
